export default __webpack_public_path__ + "static/media/reports-21.f7182ac0.png";